import { bearerAuth } from "../standardAuthPatterns";
import { defineProduct, productVariant } from "../types";
import { oauthSetupSteps } from "../oauthSetupSteps";
import { oauthAuth } from "../standardAuthPatterns";
import logo from "./logo.svg";

const credential = productVariant({
  authLabel: "API token",
  identifier: "railway",
  protocol: "http",
  defaultUrlPattern: () => "https://backboard\\.railway\\.app/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [Railway](https://railway.app/) and navigate to **Account Settings** > **Tokens** to create a new API token.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "Railway API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://backboard.railway.app/graphql/v2",
  },
});

export const railway = defineProduct({
  name: "Railway",
  tagLine: "App deployment platform",
  logo,
  tags: ["engineering"],
  variants: [
    credential,
    productVariant({
      identifier: "railwayOAuth",
      authLabel: "OAuth",
      protocol: "http",
      defaultUrlPattern: () =>
        "https://backboard\\.railway\\.com/(?:graphql/v2(?:\\?.*)?|oauth/me(?:\\?.*)?)$",
      auth: oauthAuth,
      steps: oauthSetupSteps({
        identifier: "railwayOAuth",
        registrationUrl: "https://railway.com/workspace",
        scopes: ["openid", "profile", "offline_access"],
        instructions:
          "Create an OAuth app under your workspace’s Developer settings. Add workspace or project scopes for the resources your workflow needs.",
      }),
      oauth: {
        grantType: () => "authorization_code",
        authorizationEndpoint: () => "https://backboard.railway.com/oauth/auth",
        tokenEndpoint: () => "https://backboard.railway.com/oauth/token",
        tokenEndpointAuthMethod: () => "client_secret_basic",
        clientCredentialsFrom: "db",
        scopes: () => ["openid", "profile", "offline_access"],
        authorizationParameters: () => ({ prompt: "consent" }),
        pkce: () => true,
        issuer: () => "https://backboard.railway.com",
      },
      connectionTest: {
        protocol: "http",
        request: () => "https://backboard.railway.com/oauth/me",
      },
    }),
  ],
});
